export default {"src":"/_next/static/media/0x2170ed0880ac9a755fd29b2688956bd959f933f8.8d8e3ad1.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};